import React from "react";
import {Table} from "antd";
import styled from "styled-components";

const AppTableWrapper = styled(Table)`
  .ant-table-column-sorters {
    display: flex;
    align-items: center;
    .ant-table-column-sorter-inner {
      margin: 0 !important;
    }
    .ant-table-column-sorter {
        margin-left: 10px;
    }
  }
  .action-btn {
    width: 30px;
    height: 30px;
  }
  .status-btn {
    height: 30px;
    min-width: 60px;
  }
  .ant-table-pagination {
    padding-right: 10px !important;
    margin-bottom: 0 !important;
    @media (max-width: 575.98px) {
      justify-content: center;
      float: inherit !important;
    }
  }
`;

const AppTable = (props) => {
  return (
    <AppTableWrapper
      className="gx-table-responsive"
      {...props}
    />
  );
};

export default AppTable;
